import React from "react";
import { RouteProps, Route } from "react-router";
import { ModalProvider } from "../contexts/ModalContext";

export function ModalAvailableRoute(props: RouteProps) {
  return (
    <ModalProvider>
      <Route {...props} />
    </ModalProvider>
  );
}
